import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import CreateEVACDeviceProvider from "./baseProviders/createEVACDeviceProvider"
import useStartNewEVACDeviceVersion from "../../../../../services/middleware/hooks/devices/lct/useStartNewEVACDeviceVersion"

interface INewEVACDeviceVersionFormUrlParams {
    deviceRef: string
}

interface INewEVACDeviceVersionProviderProps {
    children: ReactNode
}

const NewEVACDeviceVersionProvider = ({
    children,
}: INewEVACDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewEVACDeviceVersionFormUrlParams
    >() as INewEVACDeviceVersionFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: newEVACDeviceVersionError,
        apiResSystemRef: systemReference,
    } = useStartNewEVACDeviceVersion(urlDeviceRef, attachmentUUID)

    return (
        <CreateEVACDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newEVACDeviceVersionError}
            attachmentUUID={attachmentUUID}
            systemReference={systemReference ?? ""}
            canEditManufacturer={false}
            isNewVersion
        >
            {children}
        </CreateEVACDeviceProvider>
    )
}

export default NewEVACDeviceVersionProvider
